module.exports = __webpack_public_path__ + "static/freiexemplar-f5b29e6ee2c8c0e0c25bb777e1c1930a.png";